/**
 * Tells whoever suspended an employee what happened to the salary records.
 * Stays on screen until closed: a deleted record is not something to miss.
 * The notices arrive translated from the server.
 */
export default function notifySalaryCleanup(notification, t, response) {
  const notices = response?.salaryCleanup?.notices;
  if (!notices?.length) return;

  notification.warning({
    message: t('warning', { ns: 'messages' }),
    duration: 0,
    description: (
      <ul className="m-0 list-none space-y-1 p-0">
        {notices.map((notice) => (
          <li key={notice}>{notice}</li>
        ))}
      </ul>
    ),
  });
}
